import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "relative min-h-[288px] mt-3" }
const _hoisted_3 = { class: "border-gray-300 border rounded-md text-sm overflow-none" }
const _hoisted_4 = { class: "flex flex-col h-72 w-full overflow-y-auto py-4 px-3" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "text-black font-semibold text-sm" }
const _hoisted_7 = ["innerHTML"]

import { SearchIcon } from "@heroicons/vue/solid"
import { computed, ref } from "vue"
import GgmsInput from "@/components/GgmsInput.vue"
import { Template, TemplateCategory } from "@/shared/models/template"
import { useTemplateStore } from "@/stores/template"
import { useMessageStore } from "@/stores/message"


export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateSelectStep',
  props: {
    modelValue: {},
    category: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const templateStore = useTemplateStore()
const messageStore = useMessageStore()

const searchTerm = ref("")
const model = computed<Template>({
    get() {
        return props.modelValue as Template
    },
    set(value: Template) {
        emit("update:modelValue", value)
    },
})
const optionsFrom = computed<Template[]>(() =>
    messageStore.config.templates?.length
        ? messageStore.config.templates.filter((template) => template.templateType === "sms")
        : templateStore.tableState.data.filter((template) => template.templateType === props.modelValue?.templateType)
)
const options = computed<Template[]>(() => {
    return optionsFrom.value.filter((template: Template) => {
        return (
            template.subject?.toLocaleLowerCase()?.includes(searchTerm.value?.toLocaleLowerCase() ?? "") ||
            template.body?.toLocaleLowerCase()?.includes(searchTerm.value?.toLocaleLowerCase() ?? "") ||
            template.displayName?.toLocaleLowerCase()?.includes(searchTerm.value?.toLocaleLowerCase() ?? "")
        )
    })
})

function getMessageTemplateName(template: Template) {
    return template.subject ? `${template.displayName} - ${template.subject}` : template.displayName
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(GgmsInput, {
      modelValue: searchTerm.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
      iconStart: _unref(SearchIcon),
      placeholder: "Search"
    }, null, 8, ["modelValue", "iconStart"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "flex flex-col w-full border-b border-b-1 last:border-0 py-2 px-1 first:pt-0 cursor-pointer hover:bg-gray-50 hover:ring-1 hover:ring-gray-400 hover:rounded-md",
              key: option._id,
              onClick: ($event: any) => (model.value = option)
            }, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(getMessageTemplateName(option)), 1),
              _createElementVNode("div", {
                innerHTML: option.body,
                class: "text-gray-500 text-sm font-normal truncate mt-0.5"
              }, null, 8, _hoisted_7)
            ], 8, _hoisted_5))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})